import { render, staticRenderFns } from "./sgh-popup.vue?vue&type=template&id=548b7a8c&scoped=true"
import script from "./sgh-popup.vue?vue&type=script&lang=js"
export * from "./sgh-popup.vue?vue&type=script&lang=js"
import style0 from "./sgh-popup.vue?vue&type=style&index=0&id=548b7a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548b7a8c",
  null
  
)

export default component.exports